import { STATIC_CDN_URL } from '../../config';

/**
 * Convert a relative or absolute image path to a full URL
 * @param {string} imageUrl - The image URL or path
 * @returns {string} Full image URL
 */
export const getFullImageUrl = (imageUrl) => {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
    }
    return `${STATIC_CDN_URL}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
};
